module.exports = __webpack_public_path__ + "img/EXTERIOR-SWIFT-SPORT-2.120a5ea9.jpg";